<template>
        <v-menu open-on-hover :max-width="maxWidth">
            <template v-slot:activator="{ on }">
                <v-icon v-on="on" :small="small" :color="color">mdi-help-circle-outline</v-icon> 
            </template>

            <cards-body :hide-title="hideTitle" :title="title" no-btn-create>
                <span v-html="text"></span>
            </cards-body>
        </v-menu>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    hideTitle: { type: Boolean, default: false},
    small: { type: Boolean, default: true },
    maxWidth: { type: String, default: '250px'},
    color: { type: String, default: 'indigo' },
    title: { type: String, required: false },
    text: { type: String, default: null }
})
</script>